import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden" aria-label="网站首屏介绍">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20illustration%20of%20colorful%20speech%20bubbles%20and%20watermelon%20slices%20floating%20over%20a%20deep%20crimson%20and%20dark%20green%20gradient%20background%2C%20abstract%20editorial%20art%2C%20dramatic%20lighting%2C%20high%20contrast%2C%20rich%20saturated%20tones%2C%20no%20people%2C%20no%20text&width=1600&height=900&seq=chigua-hero-01&orientation=landscape"
          alt="吃瓜群精选主题插画：热闹的对话气泡与西瓜元素"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative w-full px-4 pb-44 pt-20 md:px-6 md:pb-52 md:pt-28">
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 font-label text-xs text-white/90 backdrop-blur-sm">
            <i className="ri-fire-line text-secondary-300"></i>
            51吃瓜群 · 推荐与排行
          </span>

          <h1 className="mt-6 font-heading text-3xl leading-tight text-white md:text-5xl">
            帮你找到靠谱、活跃、有料的吃瓜群
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
            我们用活跃度、管理规范与真实口碑三条标准筛选群组，替你先看一遍群规与氛围，
            把冷清群、广告群挡在门外，让你少走弯路、快速选对群。
          </p>

          <div className="mt-8 flex w-full flex-col items-stretch justify-center gap-3 sm:w-auto sm:flex-row sm:items-center">
            <Link
              to="/ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-trophy-line"></i>
              查看群组排行
            </Link>
            <Link
              to="/guide"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-6 py-3 font-label text-sm text-white backdrop-blur-sm transition-colors hover:bg-white/20"
            >
              <i className="ri-book-open-line"></i>
              阅读选群指南
            </Link>
          </div>

          <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs text-white/80 md:text-sm">
            <li className="inline-flex items-center gap-2">
              <i className="ri-shield-check-line text-accent-300"></i>
              只推荐免费交流群
            </li>
            <li className="inline-flex items-center gap-2">
              <i className="ri-pulse-line text-accent-300"></i>
              活跃度真实统计
            </li>
            <li className="inline-flex items-center gap-2">
              <i className="ri-refresh-line text-accent-300"></i>
              两周一次口碑复核
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}